/* @ngInject */

export default ($q, logger, productsDataFactory, authenticationService) => {
  /**
   * Clear all data from cache.
   */
  const clearCache = () => {
    logger.log('productsService', 'clearCache', 'Resolving DataFactory');
    productsDataFactory.clearCache();
  };

  /**
   * Get the asset finance available product(s).
   *
   * @param {Object} [params]
   *
   * @returns {Array}
   */
  const getAssetFinanceAvailable = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('productsService', 'getAssetFinanceAvailable', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('productsService', 'getAssetFinanceAvailable', 'Resolving DataFactory');
      productsDataFactory.getAssetFinanceAvailable(params).then((data) => {
        logger.log(
          `productsService | getAssetFinanceAvailable | Resolved ${data.length} objects`
        );
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get the asset finance net monthly surplus.
   *
   * @param {Object} [params]
   *
   * @returns {Array}
   */
  const getAssetFinanceNetMonthlySurplus = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('productsService', 'getAssetFinanceNetMonthlySurplus', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log(
        'productsService',
        'getAssetFinanceNetMonthlySurplus',
        'Resolving DataFactory'
      );
      productsDataFactory.getAssetFinanceNetMonthlySurplus(params).then((data) => {
        logger.log(
          `productsService | getAssetFinanceNetMonthlySurplus | Resolved ${data.length} objects`
        );
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get the home loan available product(s).
   *
   * @param {Object} [params]
   *
   * @returns {Array}
   */
  const getHomeLoanAvailable = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('productsService', 'getHomeLoanAvailable', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('productsService', 'getHomeLoanAvailable', 'Resolving DataFactory');
      productsDataFactory.getHomeLoanAvailable(params).then((data) => {
        logger.log(`productsService | getHomeLoanAvailable | Resolved ${data.length} objects`);
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get home loan comparison rate.
   *
   * @param {Object} [params]
   * @param {Object} [params.idProducts] - Include only Product(s) with given ID(s).
   * @param {Object} [params.comparisonRate]
   *
   * @returns {Array}
   */
  const getHomeLoanComparisonRate = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('productsService', 'getHomeLoanComparisonRate', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('productsService', 'getHomeLoanComparisonRate', 'Resolving DataFactory');
      productsDataFactory.getHomeLoanComparisonRate(params).then((data) => {
        logger.log(
          `productsService | getHomeLoanComparisonRate | Resolved ${data.length} objects`
        );
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  /**
   * Get home loan maximum borrowing.
   *
   * @param {Object} [params]
   * @param {Object} [params.idProducts] - Include only Product(s) with given ID(s).
   * @param {Object} [params.comparisonRate]
   * @param {Object} [params.maximumBorrowing]
   *
   * @returns {Array}
   */
  const getHomeLoanMaximumBorrowing = (params) => {
    const deferred = $q.defer();
    if (!authenticationService.isAuthenticated()) {
      logger.error('productsService', 'getHomeLoanMaximumBorrowing', 'Not authenticated');
      deferred.reject();
    } else {
      logger.log('productsService', 'getHomeLoanMaximumBorrowing', 'Resolving DataFactory');
      productsDataFactory.getHomeLoanMaximumBorrowing(params).then((data) => {
        logger.log(
          `productsService | getHomeLoanMaximumBorrowing | Resolved ${data.length} objects`
        );
        deferred.resolve(data);
      });
    }
    return deferred.promise;
  };

  return {
    clearCache,
    getAssetFinanceAvailable,
    getAssetFinanceNetMonthlySurplus,
    getHomeLoanAvailable,
    getHomeLoanComparisonRate,
    getHomeLoanMaximumBorrowing
  };
};
